import {
  checkDate,
  checkEmail,
  checkMultiregionalPhone,
  checkName,
  checkNotEmpty,
  checkPassport,
} from '~h/validators';

export const UserInputsFirst = [
  {
    name: 'lastName',
    label: 'Фамилия',
    type: 'text',
    error: false,
    validator: checkName,
    isForPersonal: true,
    renderBlock: 1,
  },
  {
    name: 'name',
    label: 'Имя',
    type: 'text',
    error: false,
    validator: checkName,
    isForPersonal: true,
    renderBlock: 1,
  },
  {
    name: 'patronymic',
    label: 'Отчество',
    type: 'text',
    error: false,
    validator: checkName,
    isForPersonal: true,
    renderBlock: 1,
  },
  {
    name: 'phone',
    label: 'Моб. телефон',
    type: 'phone',
    error: false,
    isForPaidEvents: false,
    alwaysDisabled: true,
    validator: checkMultiregionalPhone,
    isForPersonal: true,
    renderBlock: 1,
  },
  {
    name: 'email',
    label: 'Эл. почта',
    type: 'text',
    error: false,
    isForPaidEvents: false,
    validator: checkEmail,
    isForPersonal: true,
    renderBlock: 1,
  },
];

export const UserInputsSecond = [
  {
    name: 'company',
    label: 'Название компании',
    type: 'company',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'companyPosition',
    label: 'Должность',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: checkNotEmpty,
    renderBlock: 1,
  },
  {
    name: 'citizenship',
    label: 'Гражданство',
    type: 'country',
    classes: null,
    error: false,
    validator: checkNotEmpty,
    isForPersonal: false,
    isForCompany: true,
    required: true,
    renderBlock: 1,
  },
  {
    name: 'passport',
    label: 'Серия и номер паспорта',
    type: 'passport',
    classes: null,
    error: false,
    isForPaidEvents: true,
    isForPersonal: false,
    validator: checkNotEmpty,
    renderBlock: 2,
  },
  {
    name: 'passportCreated',
    label: 'Дата выдачи',
    type: 'date',
    classes: null,
    error: false,
    isForPaidEvents: true,
    isForPersonal: false,
    validator: checkDate,
    renderBlock: 2,
  },
  {
    name: 'birthday',
    label: 'Дата рождения',
    type: 'date',
    classes: null,
    error: false,
    isForPaidEvents: true,
    isForPersonal: false,
    validator: checkDate,
    renderBlock: 2,
  },
  {
    name: 'passportPlaceCreated',
    label: 'Кем выдан',
    type: 'ufms',
    classes: 'inp--lg',
    error: false,
    isForPaidEvents: true,
    isForPersonal: false,
    validator: checkNotEmpty,
    renderBlock: 3,
  },
  {
    name: 'addressOfRegistration',
    label: 'Адрес регистрации',
    type: 'address',
    classes: 'inp--lg',
    error: false,
    isForPaidEvents: true,
    isForPersonal: false,
    validator: checkNotEmpty,
    renderBlock: 3,
  },
];

export const UserInputsThird = [
  {
    name: 'diplomaRegNumber',
    label: 'Рег. номер диплома и дата выдачи',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: () => {},
    renderBlock: 1,
  },
  {
    name: 'diplomaQualification',
    label: 'Присвоенная квалификация',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: () => {},
    renderBlock: 1,
  },
  {
    name: 'diplomaSeries',
    label: 'Серия диплома',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: () => {},
    renderBlock: 1,
  },
  {
    name: 'diplomaNumber',
    label: 'Номер диплома',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: () => {},
    renderBlock: 2,
  },
  {
    name: 'snils',
    label: 'СНИЛС',
    type: 'text',
    classes: null,
    error: false,
    isForPaidEvents: false,
    isForPersonal: true,
    validator: () => {},
    renderBlock: 2,
  },
];